/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Action constants for the app module
 */

export const APP_MOUNTED = '@@nzr/app/APP_MOUNTED'

export const HIDE_APP_DOWNLOAD_BAR = '@@nzr/app/HIDE_APP_DOWNLOAD_BAR'
export const SHOW_APP_DOWNLOAD_BAR = '@@nzr/app/SHOW_APP_DOWNLOAD_BAR'

export const SET_BOT = '@@nzr/app/SET_BOT'
export const SET_MOBILE = '@@nzr/app/SET_MOBILE'
export const SET_ONLINE = '@@nzr/app/SET_ONLINE'
export const SET_SENDING_MESSAGE = '@@nzr/app/SET_SENDING_MESSAGE'
export const SET_SENDING_TOUR = '@@nzr/app/SET_SENDING_TOUR'
export const SET_WARN_OFFLINE = '@@nzr/app/SET_WARN_OFFLINE'

export const INIT_LOCAL_STORAGE = '@@nzr/app/INIT_LOCAL_STORAGE'

export const INITIAL_LOCATION_CHANGED = '@@nzr/app/INITIAL_LOCATION_CHANGED'
export const INITIAL_LOCATION_HAS_UTM_PARAMS = '@@nzr/app/INITIAL_LOCATION_HAS_UTM_PARAMS'

export const UPDATE_NOW = '@@nzr/app/UPDATE_NOW'
